import React, { useState, useRef } from "react";
import {
  Box,
  IconButton,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";

const DeleteButtonWithConfirmation = ({
  onDelete,
  itemId,
  size = "sm",
  colorScheme = "red",
  variant = "solid",
  ariaLabel = "Delete Item",
  confirmationMessage = "Are you sure you want to delete this item? This action cannot be undone.",
  isDisabled = false,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const cancelRef = useRef();

  // Open the dialog
  const onOpenDialog = () => setIsDialogOpen(true);

  // Close the dialog
  const onCloseDialog = () => setIsDialogOpen(false);

  // Confirm delete and call the provided onDelete function
  const onConfirmDelete = () => {
    onDelete(itemId); // Call the passed delete handler with the item ID
    onCloseDialog(); // Close the dialog
  };

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      flexShrink={0}
      lineHeight={0}
      marginInlineStart={3}
      position="relative"
    >
      <IconButton
        icon={<DeleteIcon />}
        size={size}
        variant={variant}
        isDisabled={isDisabled}
        onClick={(e) => {
          e.stopPropagation();
          onOpenDialog();
        }} // Open dialog on click
        colorScheme={colorScheme}
        aria-label={ariaLabel}
      />

      <AlertDialog
        isOpen={isDialogOpen}
        leastDestructiveRef={cancelRef}
        onClose={onCloseDialog}
        isCentered
        blockScrollOnMount={false}
      >
        {/* Sit above Chakra Modal (z-index ~1400) or confirm is invisible / clicks do nothing */}
        <AlertDialogOverlay bg="blackAlpha.600" zIndex={20000}>
          <AlertDialogContent zIndex={20001} mx={4}>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>{confirmationMessage}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseDialog}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={onConfirmDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default DeleteButtonWithConfirmation;
